
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';
import {withFormik} from "formik";

export default compose(
	withFormik({
		enableReinitialize: true,
		displayName: 'FormRender', // helps with React DevTools
		mapPropsToValues: function (){
			return {}
		},
		handleSubmit: function (){}
	}),

	withProps(()=>{
		let items = [];
		items.push({ id: "datetime",    type: "datetime",       name: "Date time",      weight: 0 })
		items.push({ id: "name",        type: "textfield",      name: "Passenger name", weight: 1, required: true });
		items.push({ id: "email",       type: "email",          name: "E-Mail",         weight: 2, required: true })
		items.push({ id: "phone",       type: "phone",          name: "Phone",          weight: 3, required: true })
		items.push({ id: "submit",      type: "submit",         name: "Submit",         weight: 4 })

		return { items }
	}),
	withProps(({ isSubmitting, errors })=>{
		let disabled = false;

		if(Object.keys(errors).length){ disabled = true; }
		if(isSubmitting){disabled = true; }

		debug({ isSubmitting })
		return { submitProps: { disabled }}
	})
)